class CartAttribute extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.handleChange.bind(this));
  }

  handleChange(event) {
    if (event.target.getAttribute('name') === 'attributes[reusable_packaging]') {
      const value = event.target.checked ? 'true' : '';
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { reusable_packaging: value } }),
        keepalive: true
      })
      .then(response => {
        console.log('Response:', response);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }
}


if (!window.customElements.get('cart-attribute')) {
  window.customElements.define('cart-attribute', CartAttribute);
}
